import DefaultActionManager from "../action_managers/default_action_manager";

export const showFeedImportActionName = "SHOW_FEED_IMPORT";
export const episodeFeedImportActionName = "EPISODE_FEED_IMPORT";

export function submitShowFeedImport(feedURL) {
  return new ShowFeedImportActionManager({
    auth: true,
    method: "post",
    route: "shows/import",
    body: { feedURL: feedURL },
    actionName: showFeedImportActionName,
  }).run();
}

export function submitEpisodesFeedImport(showUUID, feedURL, bitrate) {
  return new EpisodeFeedImportActionManager({
    auth: true,
    method: "post",
    route: "shows/" + showUUID + "/import",
    body: {
      feedURL,
      bitrate,
    },
    actionName: episodeFeedImportActionName,
  }).run();
}

class EpisodeFeedImportActionManager extends DefaultActionManager {
  responseOK(dispatch, json) {
    super.responseOK(dispatch, json);
    this.showSuccess(
      dispatch,
      "Success! Your podcast has been created and episodes are being imported now.  Should just take a few minutes."
    );
  }
}

class ShowFeedImportActionManager extends DefaultActionManager {
  response400(dispatch, json) {
    super.response400(dispatch, json);

    var errorMessage = `Looks like something went wrong importing your feed: ${json.message}. Check your podcast RSS feed and give it another go. If that doesn't work contact support, we're happy to help.`;
    this.showError(dispatch, errorMessage);
  }
}
